"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINDER = void 0;
exports.FINDER = "https://finder.terra.money";
//# sourceMappingURL=index.js.map